import { createFileRoute } from '@tanstack/react-router';
import { PreferencesTab } from '@/features/carriers/preferences/preferences-tab';

// S14 · Model preferences + dry run (07 §4).
export const Route = createFileRoute('/_app/carriers/$code/preferences')({
  component: PreferencesTab,
});
